/**
 * Product Sales Report Repository Implementation
 *
 * Repository implementation for the Product Sales Report feature
 */

import {ProductSalesReportAPIDataSource} from '../api/ProductSalesReportAPIDataSource';
import {ProductSalesReportRepository} from './ProductSalesReportRepository';
import {
  ProductSalesReportData,
  ProductSalesReportFilters
} from '../models/productSalesReport.model';
import {productSalesReportMapper} from '../mappers/productSalesReport.mapper';

export class ProductSalesReportRepositoryImpl implements ProductSalesReportRepository {
  constructor(private apiDataSource: ProductSalesReportAPIDataSource) {}

  async getProductSalesReport(filters?: ProductSalesReportFilters): Promise<ProductSalesReportData> {
    try {
      const response = await this.apiDataSource.getProductSalesReport(filters);
      return productSalesReportMapper.toProductSalesReportData(response.data);
    } catch (error) {
      throw new Error(
        `Failed to fetch product sales report: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`
      );
    }
  }
}

